import type { Option } from '@comparit/core';
import { JahreBeimVorversicherer } from '../../../interfaces';

export const jahreBeimVorversichererOptions: Option<JahreBeimVorversicherer>[] = [
  { label: 'Nicht bekannt', value: JahreBeimVorversicherer.NichtBekannt },
  { label: 'Bis zu 1 Jahr', value: JahreBeimVorversicherer.Bis1Jahr },
  { label: 'Länger als 1 Jahr', value: JahreBeimVorversicherer.Laenger1Jahr },
  { label: 'Länger als 3 Jahre', value: JahreBeimVorversicherer.Laenger3Jahre },
  { label: 'Länger als 5 Jahre', value: JahreBeimVorversicherer.Laenger5Jahre },
];
